import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';

interface ShipmentStatusChartProps {
  data: Record<string, number> | undefined;
}

const ShipmentStatusChart = ({ data }: ShipmentStatusChartProps) => {
  if (!data) {
    return <div className="text-center text-gray-400">No data available for chart.</div>;
  }

  const chartData = Object.entries(data).map(([name, value]) => ({
    name: name.charAt(0).toUpperCase() + name.slice(1).replace('_', ' '),
    count: value,
  }));

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={chartData} margin={{ top: 5, right: 20, left: -10, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey="name" tick={{ fontSize: 12 }} />
        <YAxis allowDecimals={false} tick={{ fontSize: 12 }} />
        <Tooltip
          cursor={{ fill: 'rgba(239, 246, 255, 0.5)' }}
          contentStyle={{
            background: 'white',
            border: '1px solid #e2e8f0',
            borderRadius: '0.5rem',
            fontSize: '12px',
            padding: '8px',
          }}
        />
        <Bar dataKey="count" fill="#3B82F6" barSize={30} radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ShipmentStatusChart; 